import http from "./AxiosInstance";

class ClientService {
  
  // Clients
  getClient() {
    return http.get("/client/beneficiaires/all");
  }

  getTypeClient(idType) {
    return http.get(`/client/${idType}`);
  }

  createClient(data){
    return http.post("/client/create", data)
  }

  updateClient(data, id) {
    return http.put(`/client/update/v2/${id}`, data);
  }

  updateClientV2(data, id) {
    return http.put(`/client/update/v2/${id}`, data);
  }

  deleteClient(id) {
    return http.delete(`/client/delete/${id}`);
  }

  // Bénéficiaires
  getClientBeneficiaires(idClient) {
    return http.get(`/client/${idClient}/beneficiaires`);
  }

  getClientWithBeneficiaires(idClient) {
    return http.get(`/client/${idClient}`);
  }

  addBeneficiaire(idClient, beneficiaireData) {
    return http.post(`/client/${idClient}/beneficiaire`, beneficiaireData);
  }

  updateBeneficiaire(idBeneficiaire, beneficiaireData) {
    return http.put(`/client/beneficiaire/${idBeneficiaire}`, beneficiaireData);
  }

  deleteBeneficiaire(idBeneficiaire) {
    return http.delete(`/client/beneficiaire/${idBeneficiaire}`);
  }

  // Méthode pour créer un client avec ses bénéficiaires
  createClientWithBeneficiaires(clientData) {
    return http.post("/client/create", clientData);
  }

  // Méthode pour mettre à jour un client avec ses bénéficiaires
  updateClientWithBeneficiaires(idClient, clientData) {
    return http.put(`/client/update/${idClient}`, clientData);
  }


}

const clientService = new ClientService();
export default clientService;